import { useQuery } from '@tanstack/react-query';
import { getDownloadTemplateForecast } from 'services/api/requests/uploads/uploads';
export const useDownloadTemplateForecast = () => {
	return useQuery(
		['download-template-forecast'],
		getDownloadTemplateForecast,
		{
			refetchOnWindowFocus: false,
			enabled: false,
		}
	);
};
